import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { emptyDivTestId } from "../../constants/uiConstants";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  VMDB_PDB_STOP_POLL_DELAY,
  VMDB_PDB_STOP_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface VmDbStopPdbProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const VmDbStopPdb = (
  { location, databaseId, onExecute }: VmDbStopPdbProps,
): JSX.Element => {
  const { invokeCall: invokeStopPDB } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).vmDatabaseApi.stopVmdbPluggableDatabase },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName: pdbName } = parseId(databaseId);
    const resGroup = decodeURIComponent(resourceGroup || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.stopVMDb(),
          message: Messages.notifications.inProgress.messages.stopVMDb(pdbName),
        },
        success: {
          title: Messages.notifications.success.titles.stopVMDb(),
          message: Messages.notifications.success.messages.stopVMDb(pdbName),
        },
        failure: {
          title: Messages.notifications.failure.titles.stop(),
          message: Messages.notifications.failure.messages.stopVMDb(pdbName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.VMDB_PDB_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName: resGroup,
            pluggableDatabaseName: pdbName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.VMDB_STOPPED_CHECK_PDB,
          delay: VMDB_PDB_STOP_POLL_DELAY,
          interval: VMDB_PDB_STOP_POLL_INTERVAL,
        },
      },
    };

    invokeStopPDB({
      subscriptionId,
      resourceGroupName: resGroup,
      pluggableDatabaseName: pdbName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div data-test-id={emptyDivTestId} />;
};

export const newVmDbStopPdb = (
  props: VmDbStopPdbProps,
): JSX.Element => (<VmDbStopPdb {...props} />);
